import ModalBox from "./ModalBox";

export default ModalBox;
